import {
  CLEAR_FILTERS,
  CHANGE_ADDRESS_FILTER,
  CHANGE_PAGE,
  CHANGE_PROPERTY_FILTER,
  CHANGE_SEARCH_TEXT,
  CHANGE_SORT,
  SET_FULL_QUERY,
  SELECT_INVESTMENT_TYPE,
  SELECT_TRANSACTION_TYPE,
  SELECT_PROPERTY_TYPE
} from '../actions/query';
import { initialState } from '../../../requirements_constants';

export default function(state = {}, action) {
  switch (action.type) {
  case CLEAR_FILTERS: {
    return {
      ...state,
      ...initialState,
      page: 1,
      addressFilter: { ...initialState.addressFilter },
      propertyFilter: { ...initialState.propertyFilter }
    };
  }
  case CHANGE_PAGE: {
    return { ...state, page: action.page };
  }
  case CHANGE_SEARCH_TEXT: {
    return { ...state, searchText: action.text };
  }
  case CHANGE_SORT: {
    return { ...state, sort: action.sort, page: 1 };
  }
  case CHANGE_ADDRESS_FILTER: {
    const addressFilter = { ...state.addressFilter, ...action.addressFilter };
    return {
      ...state,
      addressFilter: addressFilter,
      page: 1
    };
  }
  case CHANGE_PROPERTY_FILTER: {
    const propertyFilter = { ...state.propertyFilter, ...action.propertyFilter };
    return {
      ...state,
      propertyFilter: propertyFilter,
      page: 1
    };
  }
  case SELECT_INVESTMENT_TYPE: {
    let { investmentTypes } = { ...state };
    investmentTypes = _.reject(investmentTypes, t => t === action.id);

    if (action.value) investmentTypes.push(action.id);

    return {
      ...state,
      investmentTypes,
      page: 1
    };
  }
  case SELECT_TRANSACTION_TYPE: {
    let transactionTypes = state.transactionTypes;
    transactionTypes = _.reject(transactionTypes, t => t === action.id);
    if (action.value) {
      transactionTypes.push(action.id);
    }
    return {
      ...state,
      transactionTypes: transactionTypes,
      page: 1
    };
  }
  case SELECT_PROPERTY_TYPE: {
    let propertyTypes = state.propertyTypes;
    propertyTypes = _.reject(propertyTypes, t => parseInt(t) == parseInt(action.id));
    if (action.value) {
      propertyTypes.push(action.id);
    }
    return {
      ...state,
      propertyTypes: propertyTypes,
      page: 1
    };
  }
  case SET_FULL_QUERY: {
    return {
      ...state,
      ...action.query
    };
  }
  default:
    return state;
  }
}
